export interface PricingTier {
  name: string;
  members: string;
  price: string;
}

export const PRICING_TIERS: Record<string, PricingTier> = {
  tier1: { name: 'Liten', members: 'Upp till 15 fastigheter', price: '99 kr/mån' },
  tier2: { name: 'Standard', members: '16–100 fastigheter', price: '199 kr/mån' },
  tier3: { name: 'Stor', members: '101–250 fastigheter', price: '299 kr/mån' },
  tier4: { name: 'Extra stor', members: 'Över 250 fastigheter', price: '399 kr/mån' },
};

export const PRICE_RANGE_TEXT = '99–399 kr/månad';
